<!--
 * @Description: 睡眠得分
 * @Author: Zhang Xin (1483812724@qq.com)
 * @Date: 2023-08-23 10:10:44
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @LastEditTime: 2023-11-15 15:14:36
 -->
<template>
  <div class="sleepScore">
    <div class="eacharts">
      <echarts :chart-id="'sleepScore'" :chart-option="options"></echarts>
    </div>
    <div class="type">
      <span> <i style="background-color: #01c1ae"></i> 优秀 </span>
      <span> <i style="background-color: #01b0fe"></i> 良好 </span>
      <span> <i style="background-color: #9a61f7"></i> 中等 </span>
      <span> <i style="background-color: #ffd561"></i> 较差 </span>
      <span> <i style="background-color: #ff5a84"></i> 极差 </span>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    sleepScore: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      score: '',
      options: {
        color: ["#01C1AE", "#01B0FE", "#9A61F7", "#FFD561", "#FF5A84"],
        series: [
          {
            type: "pie",
            radius: '60%',
            data: [
              {
                name: "优秀",
                value: 3000,
              },
              {
                name: "良好",
                value: 2800,
              },
              {
                name: "中等",
                value: 2500,
              },
              {
                name: "较差",
                value: 2000,
              },
              {
                name: "极差",
                value: 1600,
              },
            ],
            label: {
              // 饼图文字的显示
              show: true, // 显示文字
              formatter: function (arg) {
                // return `${
                //   "{cstyle|" + arg.percent + "%" + "}"
                // }\n${"{b|" + arg.name + "}"}`;
                return `${"{b|" + arg.name + "}"}\n${
                  "{cstyle|" + arg.percent + "%" + "}"
                }`;
              },
              rich: {
                // 因为label不支持html片段，所以css样式需要使用rich给添加进去  // formatter: '{b|{b}}\n{cstyle|{c}}', 详见https://echarts.apache.org/zh/option.html#series-pie.label
                b: {
                  color: "#333333",
                  fontSize: 12,
                  fontWeight: 'bold',
                },
                cstyle: {
                  color: "#999999",
                },
              },
            },
            // radius: 20, // 饼图的半径
            //   radius: '20%' ,// 百分比参照的是宽度和高度中较小的那一部分的一半来进行百分比设置
            //   radius: ['50%', '75%'], // 第0个元素代表的是內圆的半径 第1个元素外圆的半径
            roseType: "radius", // 南丁格尔图 饼图的每一个区域的半径是不同的
            //  selectedMode: 'multiple',
            selectedOffset: 30,
          },
        ],
      },
    };
  },
  created() {
    let score = this.sleepScore.avg ? this.sleepScore.avg : 0
    this.score = score
    let sss = {...this.options}
    sss.series[0].data[0].value = this.sleepScore.best
    sss.series[0].data[1].value = this.sleepScore.good
    sss.series[0].data[2].value = this.sleepScore.middling
    sss.series[0].data[3].value = this.sleepScore.bad
    sss.series[0].data[4].value = this.sleepScore.worst
    this.options = {...sss}
  },
  watch: {
    sleepScore: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.sleepScore = newVal
          let score = this.sleepScore.avg ? this.sleepScore.avg : 0
          this.score = score
          let sss = {...this.options}
          sss.series[0].data[0].value = this.sleepScore.best
          sss.series[0].data[1].value = this.sleepScore.good
          sss.series[0].data[2].value = this.sleepScore.middling
          sss.series[0].data[3].value = this.sleepScore.bad
          sss.series[0].data[4].value = this.sleepScore.worst
          this.options = {...sss}
        } else {
          this.sleepScore = oldVal
        }
      },
      deep: true,
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.sleepScore {
  width: 100%;
  position: relative;
  .eacharts {
    width: 100%;
    height: 300px;
  }
  .type {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    padding: 0 20px;
    justify-content: space-between;
    > span {
      font-size: 14px;
      display: block;
      margin-left: 20px;
      i {
        display: inline-block;
        width: 15px;
        height: 6px;
        border-radius: 30px;
        vertical-align: 2px;
      }
    }
  }
}
</style>